{
  "#LAGERPLATZ_UMLAGERUNG": {
    "APP": "Umlagerung Lagerplatz",
    "APP_DESC": "Interne Lagerumbuchung",
    "TITLE": "Umlagerung Lagerplatz",
    "STEP": "Schritt {{step}} von {{total}}",
    "PAGES": {
      "QUELLLAGERPLATZ_SCANNEN": {
        "TITLE": "Quell-Lagerplatz scannen",
        "DESCRIPTION": "Bitte scannen Sie einen Lagerplatz-Barcode"
      },
      "ARTIKEL_AUSWAHL": {
        "TITLE": "Artikel auswählen",
        "DESCRIPTION": "Bitte Artikel auswählen",
        "QUELL_LAGERPLATZ": "Quell-Lagerplatz",
        "ARTIKEL": "Artikel",
        "MENGE": "Menge",
        "CHANGE": "Ändern",
        "SUBMIT": "Weiter",
        "NO_ITEMS": "Auf diesem Lagerplatz sind keine Artikel vorhanden",
        "MISCHPALETTEN": "Mischpaletten"
      },
      "MENGEN_AUSWAHL": {
        "TITLE": "Menge auswählen",
        "DESCRIPTION": "Bitte Menge auswählen",
        "QUELL_LAGERPLATZ": "Quell-Lagerplatz",
        "ARTIKEL": "Artikel",
        "MENGE": "Menge",
        "CHANGE": "Ändern",
        "SUBMIT": "Weiter"
      },
      "ZIELLAGERPLATZ_SCANNEN": {
        "TITLE": "Ziellagerplatz scannen",
        "DESCRIPTION": "Bitte scannen Sie den Ziellagerplatz",
        "QUELL_LAGERPLATZ": "Quell-Lagerplatz",
        "ARTIKEL": "Artikel + Menge"
      }
    },
    "MESSAGES": {
      "SUCCESS": {
        "UMLAGERUNG": "Die Artikel wurden dem neuen Lagerplatz zugewiesen"
      },
      "ERROR": {
        "KEINE_ARTIKEL": "Auf dieser Palette befinden sich keine Artikel",
        "ZU_VIELE_ARTIKEL": "Auf dieser Palette befinden sich mehr als ein Artikel",
        "ARTIKEL_NICHT_VORHANDEN": "Der Artikel dieser Palette ist nicht am Lagerplatz vorhanden"
      }
    }
  }
}
